import _isString from "lodash/isString";
import _pure from "recompose/pure";
import _onlyUpdateForKeys from "recompose/onlyUpdateForKeys";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

import React, { Component, Children, Fragment, cloneElement } from 'react';
import cx from 'classnames';
import { Checkbox, Radio, Tooltip } from '@nextiva/next-ui';
import Cell from "./Cell";
import TableRow from "./TableRow";
import TableRowColumn from "./TableRowColumn";
import TablePopover from "./TablePopover";

var enhance = _onlyUpdateForKeys(['idx', 'isSelected', 'isDisabled', 'preferences', 'data', 'tableMetadata', 'checkable', 'multi', 'allowSelectionOnRowClick']);

var DataTableRow =
/*#__PURE__*/
function (_Component) {
  _inherits(DataTableRow, _Component);

  function DataTableRow() {
    var _ref;

    var _temp, _this;

    _classCallCheck(this, DataTableRow);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_ref = DataTableRow.__proto__ || Object.getPrototypeOf(DataTableRow)).call.apply(_ref, [this].concat(args))), Object.defineProperty(_assertThisInitialized(_this), "handleCheckableChange", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(event) {
        var _this$props = _this.props,
            idx = _this$props.idx,
            onRowSelect = _this$props.onRowSelect;
        onRowSelect(event, idx);
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "handlePreviewClick", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(event) {
        var _this$props2 = _this.props,
            onPreviewClick = _this$props2.onPreviewClick,
            data = _this$props2.data,
            allowSelectionOnRowClick = _this$props2.allowSelectionOnRowClick;
        allowSelectionOnRowClick && event.stopPropagation();

        var actionsParams = _this.getActionsParams({
          rowData: data
        });

        return onPreviewClick(event, actionsParams);
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "getCellParams", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(_ref2) {
        var rowData = _ref2.rowData,
            name = _ref2.name,
            idx = _ref2.idx;
        var _this$props3 = _this.props,
            tableMetadata = _this$props3.tableMetadata,
            cellRenderers = _this$props3.cellRenderers,
            isDisabled = _this$props3.isDisabled;
        return {
          idx: idx,
          rowData: rowData,
          isDisabled: isDisabled,
          tableMetadata: tableMetadata,
          cellData: cellRenderers[name].getCellData(rowData, name),
          columnData: cellRenderers[name] && cellRenderers[name].columnData
        };
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "getActionsParams", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(_ref3) {
        var rowData = _ref3.rowData;
        var _this$props4 = _this.props,
            idx = _this$props4.idx,
            tableMetadata = _this$props4.tableMetadata,
            checkable = _this$props4.checkable,
            isSelected = _this$props4.isSelected,
            isBulk = _this$props4.isBulk;
        var selectionStatus = checkable ? {
          isSelected: isSelected,
          isBulk: isBulk()
        } : {};
        return _objectSpread({
          idx: idx,
          rowData: rowData,
          tableMetadata: tableMetadata
        }, selectionStatus);
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "renderTableBodyRowCell", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(data, _ref4) {
        var name = _ref4.name,
            valign = _ref4.valign,
            halign = _ref4.halign;
        var _this$props5 = _this.props,
            cellRenderers = _this$props5.cellRenderers,
            _this$props5$rowHeigh = _this$props5.rowHeight,
            rowHeight = _this$props5$rowHeigh === void 0 ? null : _this$props5$rowHeigh,
            idx = _this$props5.idx;
        var cellRenderer = cellRenderers[name].renderer || Cell;
        var className = cellRenderers[name].className;

        var cellParams = _this.getCellParams({
          rowData: data,
          name: name,
          idx: idx
        });

        return React.createElement(TableRowColumn, {
          key: name,
          height: rowHeight,
          valign: valign,
          halign: halign,
          className: className
        }, cellRenderer(cellParams));
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "renderColumns", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props6 = _this.props,
            data = _this$props6.data,
            preferences = _this$props6.preferences;
        return preferences.filter(function (p) {
          return p.display;
        }).map(function (preference) {
          return _this.renderTableBodyRowCell(data, preference);
        });
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "renderCheckable", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props7 = _this.props,
            isSelected = _this$props7.isSelected,
            isDisabled = _this$props7.isDisabled,
            multi = _this$props7.multi;
        var Component = multi ? Checkbox : Radio;
        return React.createElement("div", {
          className: "nx-table__row-checkbox"
        }, React.createElement(Component, {
          onChange: _this.handleCheckableChange,
          shouldPropagate: false,
          checked: isSelected,
          disabled: isDisabled,
          size: 16
        }));
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "renderPreviewIcon", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        var hidePreview = _this.props.hidePreview;

        if (hidePreview) {
          return React.createElement("div", {
            className: "nx-table__row-preview"
          });
        }

        return React.createElement(Tooltip, {
          text: "Preview",
          delay: 1000,
          dark: true
        }, React.createElement("span", {
          className: "nx-table__row-preview",
          onClick: _this.handlePreviewClick
        }, React.createElement("i", {
          className: "icon-custom-eye"
        })));
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "renderActionsContent", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        return React.createElement(Tooltip, {
          text: "Click for additional options",
          delay: 1000,
          dark: true,
          shouldCloseOnClick: true
        }, React.createElement("span", {
          className: "nx-table__actions-icon"
        }, React.createElement("i", {
          className: "icon-custom-options"
        })));
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "renderActionsBtn", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props8 = _this.props,
            data = _this$props8.data,
            renderActions = _this$props8.renderActions,
            hideActions = _this$props8.hideActions,
            getTableRef = _this$props8.getTableRef;

        if (hideActions) {
          return React.createElement("div", {
            className: "nx-table__row-actions nx-table__row-actions--empty"
          });
        }

        return React.createElement("div", {
          className: "nx-table__row-actions"
        }, React.createElement(TablePopover, {
          body: _pure(function (_ref5) {
            var togglePopover = _ref5.togglePopover,
                className = _ref5.className;

            var actionsParams = _this.getActionsParams({
              rowData: data
            });

            var Component = renderActions(_objectSpread({}, actionsParams, {
              togglePopover: togglePopover,
              className: className
            })); // avoid passing props to html element

            return _isString(Component.type) ? Component : React.cloneElement(Component, {
              togglePopover: togglePopover,
              className: className
            });
          }),
          className: "nx-table-popover__actions no-caret",
          arrow: false,
          popper: {
            modifiers: {
              offset: {
                offset: '0, 10'
              },
              preventOverflow: {
                enabled: true,
                boundariesElement: 'viewport'
              }
            }
          },
          getTableRef: getTableRef
        }, _this.renderActionsContent()));
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "renderControls", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props9 = _this.props,
            controlsColumnWidth = _this$props9.controlsColumnWidth,
            renderActions = _this$props9.renderActions,
            checkable = _this$props9.checkable,
            shouldRenderPreviewIcon = _this$props9.shouldRenderPreviewIcon,
            allowSelectionOnRowClick = _this$props9.allowSelectionOnRowClick;

        if (renderActions || checkable || shouldRenderPreviewIcon) {
          return React.createElement(TableRowColumn, {
            key: 'controls',
            width: controlsColumnWidth,
            disableClick: !allowSelectionOnRowClick
          }, checkable && _this.renderCheckable(), renderActions && _this.renderActionsBtn(), shouldRenderPreviewIcon && _this.renderPreviewIcon());
        }
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "renderTooltipTarget", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(_ref6) {
        var children = _ref6.children,
            other = _objectWithoutProperties(_ref6, ["children"]);

        return Children.map(children, function (child) {
          return cloneElement(child, _objectSpread({}, other, {
            className: cx(child.props.className, other.className)
          }));
        });
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "renderRow", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        var _cx;

        var _this$props10 = _this.props,
            data = _this$props10.data,
            idx = _this$props10.idx,
            onRowClick = _this$props10.onRowClick,
            isSelected = _this$props10.isSelected,
            isDisabled = _this$props10.isDisabled,
            allowSelectionOnRowClick = _this$props10.allowSelectionOnRowClick;
        var rowClassNameBase = 'nx-table__row';
        var rowClassName = cx(rowClassNameBase, (_cx = {}, _defineProperty(_cx, "".concat(rowClassNameBase, "--clickable"), onRowClick || allowSelectionOnRowClick), _defineProperty(_cx, "".concat(rowClassNameBase, "--selected"), isSelected), _defineProperty(_cx, "".concat(rowClassNameBase, "--disabled"), isDisabled), _cx));
        return React.createElement(TableRow, {
          ref: function ref(el) {
            return _this.rowComponent = el;
          },
          className: rowClassName,
          onRowClick: onRowClick,
          onRowClickParams: [data, idx]
        }, _this.renderControls(), _this.renderColumns(), React.createElement(TableRowColumn, {
          key: "last",
          className: "nx-table__cell--last"
        }));
      }
    }), _temp));
  }

  _createClass(DataTableRow, [{
    key: "render",
    value: function render() {
      var data = this.props.data;

      var _ref7 = data || {},
          tooltip = _ref7.tooltip;

      if (_typeof(tooltip) === 'object') {
        return React.createElement(Tooltip, _extends({
          component: Fragment,
          targetComponent: this.renderTooltipTarget,
          popper: {
            modifiers: {
              preventOverflow: {
                boundariesElement: 'viewport'
              }
            }
          }
        }, tooltip), this.renderRow());
      }

      return this.renderRow();
    }
  }]);

  return DataTableRow;
}(Component);

export default enhance(DataTableRow);